import { useClickOutside } from "hooks/useClickOutside";
import React, { forwardRef, useEffect, useRef } from "react";

import styles from './menu.module.css';

export const Menu = forwardRef(({ className,anchorEl, open,onClose,children, variant="default",...props},ref) => {
    const innerRef = useRef();
    const anchorRef = useRef();
    anchorRef.current = anchorEl;
    useClickOutside([innerRef,anchorRef], onClose);
    useEffect(() => {
        if(!open) {
            innerRef.current.style.display = 'none';
            return;
        };
        const rect = anchorEl?.getBoundingClientRect();
        const top = rect.top + window.scrollY + rect.height + 10;
        const left = rect.left + window.scrollX;
        const right = rect.right + window.scrollX;

        innerRef.current.style.top = `${top}px`;
        innerRef.current.style.left = `${left}px`;
        
        console.log("I got here", left, window.innerWidth,right);
        if(left > window.innerWidth * 55 / 100) {
            innerRef.current.style.left = `${right - (parseFloat(innerRef.current.getBoundingClientRect().width) || 200)}px`;
        }
        innerRef.current.style.display = open ?'flex' :"none";
    }, [anchorEl,open]);
    return (
        <div ref={ref}>
            <div ref={innerRef} className={`${styles.Menu} ${open ? styles.open : ""} ${className|| ""} ${styles[variant]}`} {...props}>
                {children}
            </div>
        </div>
    )
})

export const MenuItem = ({children,  className, ...props}) => {
    return(
        <div className={`${className|| ""}`} {...props}>{children}</div>
    )
}
